
import { ref, watch } from 'vue'

const STORAGE_KEY = 'tt-theme'

// Read the theme the inline script in index.html already applied, so Vue's
// state matches what's on screen from the very first render.
function getInitialTheme() {
  if (typeof document !== 'undefined') {
    const current = document.documentElement.getAttribute('data-theme')
    if (current) return current
  }
  return 'light'
}

// Shared, module-scoped reactive state (singleton).
const theme = ref(getInitialTheme())

// Whenever the theme ref changes, reflect it to the DOM and persist it.
watch(
  theme,
  (value) => {
    document.documentElement.setAttribute('data-theme', value)
    try {
      localStorage.setItem(STORAGE_KEY, value)
    } catch {
      /* Storage can be blocked; the in-memory value still works this session. */
    }
  },
  { immediate: true }
)

export function useTheme() {
  const toggleTheme = () => {
    theme.value = theme.value === 'dark' ? 'light' : 'dark'
  }

  const setTheme = (value) => {
    theme.value = value === 'dark' ? 'dark' : 'light'
  }

  return { theme, toggleTheme, setTheme }
}
